module.exports = __webpack_public_path__ + "static/media/worldmap_bg.747fe92c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/worldmap_bg.jpg
// module id = 113
// module chunks = 0